import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { LazyMarkdown } from '@sorare/core/src/atoms/markdown/LazyMarkdown';
import { useWalletDrawerContext } from '@sorare/core/src/contexts/walletDrawer';

import { DumbNotification } from 'components/activity/DumbNotification';

import { commonNotificationInterfaceFragment } from '../fragments';
import type { CommonNotificationProps } from '../types';
import type { ExternalDepositNotification_externalDepositNotification } from './__generated__/index.graphql';

type Props = CommonNotificationProps & {
  notification: ExternalDepositNotification_externalDepositNotification;
};

export const ExternalDepositNotification = ({
  notification,
  onClick,
  ...rest
}: Props) => {
  const { showDrawer } = useWalletDrawerContext();
  const { createdAt, name, sport, read } = notification;

  return (
    <DumbNotification
      name={name}
      title={<LazyMarkdown data={notification.markdownBody} />}
      onClick={() => {
        showDrawer();
      }}
      createdAt={createdAt}
      sport={sport}
      read={read}
      {...rest}
    />
  );
};

ExternalDepositNotification.fragments = {
  externalDepositNotification: gql`
    fragment ExternalDepositNotification_externalDepositNotification on ExternalDepositNotification {
      id
      ...Notification_notificationInterface
      sport
    }
    ${commonNotificationInterfaceFragment}
  ` as TypedDocumentNode<ExternalDepositNotification_externalDepositNotification>,
};
